export default __webpack_public_path__ + "static/media/logo.4a6883f8.png";